import type { AudioGroup } from '|>/shared/types/audio'
import type { AudioTrack } from '|>/shared/types/tracks'

export const isDolbyTrack = ({
  track,
  dolbyTracks,
  isHls,
}: {
  track?: AudioTrack
  dolbyTracks?: AudioGroup[]
  isHls: boolean
}): boolean => {
  if (!dolbyTracks?.length || !track) return false

  // hls case
  if (isHls)
    return dolbyTracks.some(
      (dolbyTrack) =>
        track.id === dolbyTrack.name && track.language === dolbyTrack.language
    )

  // dash case
  return dolbyTracks.some(
    (dolbyTrack) =>
      track.id.startsWith(dolbyTrack.language ?? '') &&
      track.language === dolbyTrack.language
  )
}
